// extracted by mini-css-extract-plugin
export default {"learnDis":"Learn_learnDis__al4kT","learnImage":"Learn_learnImage__d3i+6","learnContent":"Learn_learnContent__hyF4g"};